import React from 'react';
import {withStyles} from "@mui/styles";
import {Styles} from "../../../config/design/styles";
import {useTranslation} from "react-i18next";
import clsx from "clsx";
import {IconButton, Typography, useMediaQuery} from "@mui/material";
import {currencySymbol, getMediaURL, getOrderStatus, price, showExactDate, truncate} from "../../../config/values";
import Badge from '@mui/material/Badge';
import Button from "@mui/material/Button";
import {Link} from "react-router-dom";
import OrderStatusIndicator from "./components/OrderStatusIndicator";
import CommentsButton from "../front/shops/components/CommentsButton";
import MakeCommentButton from "./components/MakeCommentButton";
import Courier from "../../components/icons/Courier";
import {
    BadgeInfo,
    Banknote,
    ChevronRight,
    ClipboardList,
    Clock,
    HeartHandshake,
    Star,
    UserRound
} from "lucide-react";
import Tooltip from "@mui/material/Tooltip";
import {theme} from "../../../config/design/theme";


function SingleOrderItem({order,role,classes}) {
    const { t } = useTranslation();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const order_link = role === 'user' ? '/account/view-order/' :  role === 'transport' ? '/account/delivery-order/' :  role === 'admin' ? '/panel/manage/view-order/' : '/panel/vendor/view-order/';
    const setComment = (comment) => {
        order.comment = comment;
    }
    return (
        <div  className={clsx(classes.singleOrderItem,order.status)}>
            {
                (role === "user" || role === "admin" || role === "transport") ?
                <div className="flex-direction ">
                    <Link to={`/vendor/${order.shop?.slug}`}>
                        <img className="logo" src={getMediaURL(order.shop?.logo,'small')} alt={order.shop?.name}/>
                    </Link>
                    <div>
                        <h3 className="shopName"><Link to={`/vendor/${order.shop?.slug}`}>{truncate(order.shop?.name,15)}</Link></h3>
                        <Typography className="flex-direction time" style={{gap:6}}>

                            {
                                !isMobile &&
                                <Clock className="lucide-small-narrow"/>
                            }
                            {showExactDate(order.order_time)}
                        </Typography>
                        {
                            (role === "user" || role === "transport" || role === "admin") &&
                            <Typography className="flex-direction" style={{gap:3}}>
                                {
                                    !isMobile &&
                                    <Courier className="not-lucide"/>
                                }
                                {
                                    !!order.charity &&
                                    <strong>{truncate(order.charity.name,20)}</strong>
                                }
                                {(role === "user" && !order.charity) && order.address?.label} {truncate(order.address?.manual_address,28)}
                            </Typography>
                        }

                    </div>
                </div>
                    :
                    <div >
                        <Typography className="flex-direction time" style={{gap:6}}>

                            {
                                !isMobile &&
                                <Clock className="lucide-small-narrow"/>
                            }
                            {showExactDate(order.order_time)}
                        </Typography>
                        <Typography className="flex-direction" style={{gap:3}}>
                            {
                                !isMobile &&
                                <Courier className="not-lucide"/>
                            }
                            {role === "user" && order.address?.label} {truncate(order.address?.manual_address,28)}
                        </Typography>
                    </div>
            }
            <div className="positon-top">
                <div className={clsx(classes.orderStatus,"order-status",order.status)}>
                    <Typography style={{fontSize:"12px !important"}}>{t(getOrderStatus(order))}</Typography>
                </div>
                {
                    !!order.charity &&
                    <Tooltip placement="top" title={t('thisOrderIsForCharity')+": "+truncate(order.charity.name,20)}>
                        <IconButton className="charity-icon">
                            <HeartHandshake/>
                        </IconButton>
                    </Tooltip>
                }
                {
                    !!order.is_pod &&
                    <Tooltip placement="top" title={t('podDescGeneral')}>
                        <IconButton className="charity-icon orange">
                            <Banknote/>
                        </IconButton>
                    </Tooltip>
                }
            </div>


            {
                (order.status !== "not_paid" && order.status !== "finished" && order.status !== "canceled" && order.status !== "pending") ?
                <div className="bg-gray">
                    <OrderStatusIndicator order={order} role={role}/>
                </div>
                    :
                    (order.status === "finished" || order.status === "canceled") ? null :
                    <div className="bg-gray flex-direction flex-justify-center">
                        {
                            !isMobile &&
                            <BadgeInfo className="lucide-small blue"/>
                        }
                        <Typography align="center" className="blue">
                           {
                               order.status === "not_paid" && t('payOrderToStart')
                           }
                           {
                               order.status === "pending" && t('afterConfirmationStarts')
                           }
                       </Typography>
                    </div>
            }


            <div className="items-holder">
                <div className="products-holder">
                    {
                        order.items.map((item,index) => {
                            if (index < 3) {
                                return (
                                    <div className="product-small-img" key={index}>
                                        <Badge className="badge-order-item" badgeContent={item.quantity}>
                                            <img src={getMediaURL(item.product?.thumbnail,'square')} alt={item.product?.name}/>
                                        </Badge>
                                    </div>
                                );
                            } else if (index === 3) {
                                return (
                                    <React.Fragment key={index}>
                                        <span className="more-categories"> +{order.items.length - 3}</span>
                                    </React.Fragment>
                                );
                            }
                        })
                    }
                </div>
                <div className="price-holder">
                    {price(order.total_price_paid)} {currencySymbol}
                </div>
            </div>
           <div className="flex-space" >
              <div>
                  {
                      (role === "supplier" || role === "admin" || role === "transport") &&
                      <Tooltip title={t("orderUser")} className="flex-direction" placement="left" style={{gap:3}}>
                          <UserRound className="lucide-small-narrow"/>
                          <span style={{fontSize:12}}>{truncate(order.user?.first_name + " " + order.user?.last_name , 14)}</span>
                      </Tooltip>
                  }
                  <Tooltip title={t("OrderID")} className="flex-direction" placement="left" style={{gap:3}}>
                      <ClipboardList className="lucide-small-narrow"/>
                      <span style={{fontSize:12}}>{order.number}</span>
                  </Tooltip>
              </div>

               <div className="flex-direction">
                   <Button
                       component={Link}
                       to={`${order_link}${order.number}`}
                       variant="outlined"
                       endIcon={<ChevronRight/>}
                   >
                       {t('viewDetails')}
                   </Button>
                   {
                       (role === "user" && (order.status === "finished" || order.status === "received")) &&
                       <div className='comments-holder'>
                           <MakeCommentButton
                               order={order}
                               reload={(data) => setComment(data)}
                           />
                       </div>
                   }
                   {
                       ((role === "supplier" || role === "admin") && !!order.comment) &&
                       <div className='comments-holder'>
                           <div className="comment-btn-holder flex-space">
                               <div className="flex-direction">
                                   <Tooltip title={order.comment.comment || t('noComment')} className="flex-direction" placement="right" style={{gap:2}}>
                                       <div className="flex-direction" style={{gap:0}}>
                                           <Star className="rating-icon" />
                                           {order.comment.rate}
                                       </div>
                                   </Tooltip>
                               </div>
                           </div>
                       </div>
                   }
               </div>

           </div>

        </div>
    );
}

export default withStyles(Styles)(SingleOrderItem);
